<template>
    <div class="c-slice-zone | l-grid">
        <div
            v-for="(item, index) in slices"
            :key="index"
            class="c-slice-zone__item"
        >
            <hero-card v-if="item.slice_type === 'card_hero'" :data="item" />
            <social-medias-block v-if="item.slice_type === 'social_medias'" :data="item" />
            <entrepreneur-parallax
                v-if="item.slice_type === 'parallax'"
                :item="item"
                :data="item"
            />
        </div>
    </div>
</template>

<script>
import EntrepreneurParallax from "components/EntrepreneurParallax/EntrepreneurParallax";
import HeroCard from "components/HeroCard/HeroCard";
import SocialMediasBlock from "components/SocialMediasBlock/SocialMediasBlock";

export default {
    name: "SliceZone",
    components: {
        EntrepreneurParallax,
        HeroCard,
        SocialMediasBlock,
    },
    props: {
        slices: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style lang="scss">
.c-slice-zone__item {
    display: flex;
    height: 100%;
}
</style>
